import { defaultHeadersWithToken } from "@/constants/constants";
import { expedition_validation_url } from "@/constants/urls";
import { ValidationData } from "@/interfaces/Return";
import { ServerResponse } from "@/interfaces/Server";
import { store } from "@/store/store";
import axios, { AxiosResponse } from "axios";

export async function confirmExpedition(
  returnData: ValidationData
): Promise<AxiosResponse<ServerResponse>> {
  const accessToken = store.getState().authentication.accessToken;
  try {
    const response: AxiosResponse<ServerResponse> = await axios({
      url: expedition_validation_url,
      headers: defaultHeadersWithToken(accessToken),
      data: returnData,
      method: "POST",
    });
    return response;
  } catch (error: any) {
    return error.response;
  }
}
